import React from "react";
import { MoneyDirection } from "@common/constants";
import { FiltersTypes } from "@common/types/filters/general";

export type DirectionLabelVariant = "cash" | "gl";

interface DirectionFilterLabelProps {
    filters: Pick<FiltersTypes, "direction">;
    labelVariant?: DirectionLabelVariant;
}

export const DirectionFilterLabel: React.FC<DirectionFilterLabelProps> = ({
    filters: { direction },
    labelVariant = "cash",
}) => {
    if (labelVariant === "gl") {
        return (
            <>{direction === MoneyDirection.MONEY_IN ? "Credit" : "Debit"}</>
        );
    }
    return (
        <>{direction === MoneyDirection.MONEY_IN ? "Money in" : "Money out"}</>
    );
};
